import { FormData } from ".";
import { emptyValues as emptyValuesPerson } from "../FormPartialPerson/emptyValues";

export const emptyValues: FormData = {
  person: emptyValuesPerson
};
